export function Indicator({ count }: { count: number }) {
    if (!count || count == 0) return null;
    return (
      <div className="absolute top-0 right-0 text-xs font-bold px-1 h-4 bg-red-500 text-primary-foreground rounded-full ">
        {count}
      </div>
    );
  }
